import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@bingads-webui-react/fabric-control';

export const EncodingPlaceholder = props => (
  <div className={props.classes.encoding}>
    <Icon
      className="placeholder-icon"
      iconName="ProgressRingDots"
    />
    <div className="placeholder-content" style={{ fontWeight: 600, color: props.textColor }}>{props.placeholderContent}</div>
  </div>
);

EncodingPlaceholder.propTypes = {
  placeholderContent: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  classes: PropTypes.shape({
    encoding: PropTypes.string.isRequired,
  }).isRequired,
};

EncodingPlaceholder.defaultProps = {
  textColor: undefined,
};
